module.exports = __webpack_public_path__ + "static/media/close.e703830e.svg";